import { useSyncExternalStore } from 'react'
import {
  getStudioSettingsWriteOutcome,
  subscribeStudioSettingsWriteOutcome,
  type StudioSettingsWriteOutcome,
} from '@/services/studio-settings-write-outcome'

export function useStudioSettingsWriteOutcome(): StudioSettingsWriteOutcome {
  return useSyncExternalStore(
    subscribeStudioSettingsWriteOutcome,
    getStudioSettingsWriteOutcome,
    getStudioSettingsWriteOutcome,
  )
}
